<template>
  <!-- 智能家居 -->
  <div class="scheme_container">
    <div class="scheme_wrap">
      <div class="title_wrap">{{pageData.title}}</div>
      <div class="content_wrap">
        <div class="article_box unify_article">{{pageData.text.text1}}</div>
        &nbsp;
        <div class="img_wrap" v-for="( item, index ) in pageData.imgArr" :key="`${index}-img`">
          <img :src="item.imgSrc" :alt="item.alt" />
        </div>
        &nbsp;
        <div class="article_wrap" v-for="( item, index ) in pageData.text.textArr" :key="index">
          <div class="subtitle">{{item.textTitle}}</div>
          <div class="text unify_article" v-for="(itemText, indexText) in item.textContent" :key="`${index}-${indexText}`">
            {{itemText}}
          </div>
          &nbsp;
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageData: {
          title: '智能家居',
          text: {
            text1: "秉承让人工智能创造美好生活的理念，瑞谦智能围绕智能照明、智能遮阳、智能安防、环境健康、背景音乐等系统，多方面满足客户的智能化需求，全方位打造智能、安全、舒适、人性化的家居生活体验。",
            textArr: [
              {
                textTitle: "智慧玄关",
                textContent: ["智能门锁入户；多模式联动家居设备；安防布控；APP掌控。"]
              },
              {
                textTitle: "智慧客厅",
                textContent: ["智能照明、遮阳、温控、影音以及环境监测皆可实现。"]
              },
              {
                textTitle: "智慧餐厅",
                textContent: ["不同的就餐模式和音乐灯光，提升就餐体验和品质。"]
              },
              {
                textTitle: "智慧卧室",
                textContent: ["睡眠模式和唤醒模式，让窗帘、灯光、音乐贴心助眠与唤醒。"]
              },
              {
                textTitle: "智慧书房",
                textContent: ["智能照明、温控和恒氧环境，营造舒适的学习休闲时光。"]
              },
              {
                textTitle: "智慧厨房",
                textContent: ["水电气等安全隐患监测预警，可联动物业及时处理险情。"]
              },
              {
                textTitle: "智慧卫生间",
                textContent: ["集合信息娱乐、生活服务、智能控制、健康管理。"]
              }
            ]
          },
          imgArr: [
            {
              imgSrc: require('@/assets/img/solution/pageImg/7.jpg'),
              alt: ""
            }
          ]
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "@/views/solution/unifyStyle";
.article_wrap {
  display: flex;
  flex-direction: row;
  .subtitle {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 105px;
    margin-bottom: 0;
    line-height: 2;
  }
  .unify_article {
    text-indent: 0;
  }
}
</style>
